(function ($, ServiceBus, ServiceBusTopics) {
  Drupal.behaviors.elcSdProductSppV1 = {
    attach: function (context) {
      var self = this;
      var $sppFormatter = $('.js-sd-product-spp-formatter', context);
      if (self.attached) {
        return;
      }
      self.attached = true;
      self.setupAccordion($sppFormatter);
      self.getDom(context);
      self.setEvents();
    },

    selectors: {
      sppContent: '.js-spp-content'
    },

    getDom: function (context) {
      var self = this;
      self.nodes = {};
      self.nodes.$sppContent = $(self.selectors.sppContent, context);
    },

    setEvents: function () {
      var self = this;

      if (
        ServiceBus &&
        ServiceBus.emit &&
        ServiceBusTopics &&
        ServiceBusTopics.events &&
        ServiceBusTopics.events.PRODUCT_SKU_SELECTED
      ) {
        ServiceBus.on(ServiceBusTopics.events.PRODUCT_SKU_SELECTED, function (data) {
          if (data) {
            self.nodes.$sppContent.attr('data-sku-base-id', data.payload.skuBaseId);
          }
        });
      }
    },

    setupAccordion: function ($sppFormatter) {
      var $accordions = $('.js-accordion', $sppFormatter);
      $accordions.on('click', '.js-accordion-header', function () {
        var $this = $(this);
        var $parent = $this.closest($accordions);
        var $content = $parent.find('.js-accordion-content');
        var $icon = $this.find('.js-accordion-icon');
        var isExpended = $this.attr('aria-expanded') == 'true';
        $this.attr('aria-expanded', !isExpended);
        $content.attr('aria-hidden', isExpended);
        $parent.toggleClass('collapsed');
        $icon.toggleClass('elc-accordion-plus-icon').toggleClass('elc-accordion-minus-icon');
        if (!$parent.hasClass('collapsed') && $content.find('.slick-slider').length > 0) {
          // if content is a slider, need to flag it became visible
          $(window).trigger('resize');
        }
      });
    },
    attached: false
  };
})(jQuery, window.GlobalServiceBus || {}, window.ServiceBusTopics || {});
